import styles from '../styles/ErrorWrapper.module.css';

type Props = {
  msg: string;
  name?: string;
};

const ErrorWrapper = ({ msg, name }: Props) => (
  <div className={styles.formError} data-testid={`form-error-${name}`}>
    {msg}
  </div>
);

export default ErrorWrapper;
